export enum ChatRole {
  User = 'user',
  Assistant = 'assistant'
}
